module.exports = __webpack_public_path__ + "static/media/logo_fundo_branco.3b60d061.png";